<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"  display: flex;\n  justify-content: center;\npadding-bottom:80px;\n\n"' class="rcontainer bg-white" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='" width: 480px; \/* \u0639\u0631\u0636 \u06a9\u0627\u0646\u062a\u06cc\u0646\u0631 \u0645\u062e\u0635\u0648\u0635 \u0645\u0648\u0628\u0627\u06cc\u0644 *\/\nheight:100%;\n\n\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n"' class="inner-container bg-white shadow" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto p-0 justify-content-center text-center product-container relative" >
                <template #default>   <m-products-3 v-bind='{...{"perPage":12,"productCardName":"mProductCard310","cardCLass":"my-1","cardWrapperCLass":"col-lg-12 archive-parent-item","showCategoriesSlider":false,"offerType":"number","offerStatus":true,"productBrandProp":false,"productSearchProp":true,"productQuantityProp":true,"productFeatureProp":false,"productFeaturePanelOpenCloseProp":false,"productCategoryProp":false,"productStoresProp":false,"productSortProp":true,"relatedCurrentCategory":true,"productPriceFilterProp":false,"showKeywords":false,"smCardName":"mProductCard310","skeleton":"mProductArchiveSkeleton1","dashboardProduct":false,"publishStatusFilter":false,"image":null,"alt":"","cardLink":false,"infinityLoading":true,"chooseCategoriesFromTop":true,"cardLinkTarget":"_self","productStoresDirectFilter":null,"orderFilterProp":["brand","feature","category","search","quantity","store","price"]},...{}}' :style='""' class="my-4 product-archive-3 col-12 p-0 m-0" ></m-products-3></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mProducts3 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products3/Products3';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mProducts3 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
